import { supabase } from '../lib/supabase';

export interface RoofFixedMountingPricing {
  unitPriceUsdPerKw: number;
  laborHoursPerKw?: number;
  laborRateUsdPerHour?: number;
  sourceComponentName?: string;
}

function safeNumber(n: unknown, fallback = 0): number {
  const v = typeof n === 'number' ? n : Number(n);
  return Number.isFinite(v) ? v : fallback;
}

let cachedRoofFixed: RoofFixedMountingPricing | null = null;
let cachedAtMs = 0;
const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes

export async function fetchRoofFixedMountingPricing(): Promise<RoofFixedMountingPricing | null> {
  const now = Date.now();
  if (cachedRoofFixed && now - cachedAtMs < CACHE_TTL_MS) return cachedRoofFixed;

  const { data, error } = await supabase
    .from('bos_components')
    .select('component_name, unit_price_usd, labor_hours, labor_rate_usd, availability_saudi, unit')
    .eq('category', 'mounting')
    .eq('subcategory', 'roof-fixed')
    .eq('availability_saudi', true)
    .eq('unit', 'per_kw')
    .limit(1)
    .maybeSingle();

  if (error || !data) return null;

  const unitPriceUsdPerKw = safeNumber((data as any).unit_price_usd, NaN);
  if (!Number.isFinite(unitPriceUsdPerKw) || unitPriceUsdPerKw <= 0) return null;

  const laborHoursPerKw = safeNumber((data as any).labor_hours, NaN);
  const laborRateUsdPerHour = safeNumber((data as any).labor_rate_usd, NaN);

  cachedRoofFixed = {
    unitPriceUsdPerKw,
    laborHoursPerKw: Number.isFinite(laborHoursPerKw) && laborHoursPerKw > 0 ? laborHoursPerKw : undefined,
    laborRateUsdPerHour: Number.isFinite(laborRateUsdPerHour) && laborRateUsdPerHour > 0 ? laborRateUsdPerHour : undefined,
    sourceComponentName: String((data as any).component_name || ''),
  };
  cachedAtMs = now;
  return cachedRoofFixed;
}



